import { http } from './http'

export function getKitchenContractorAudit(id, params = {}) {
  return http.get(`/api/kitchen/contractors/${id}/audit`, { params })
}

export function getKitchenOrderAudit(orderId) {
  return http.get(`/api/kitchen/orders/audit/${orderId}`)
}
